/*
  This component renders a ListWithDividers, with SimilarAuthor items.

  Ref: https://w.amazon.com/bin/view/Goodreads/Teams/Mobile_web/Responsive_SeriesList_Components_Refactor/
*/

import { PropTypes } from "react";
import ListWithDividers from "../list_with_dividers";
import SimilarAuthor from "../author/similar_author";

const SimilarAuthorsList = ({ similarAuthors }) => (
  <ListWithDividers ItemComponentType={SimilarAuthor}
                    items={similarAuthors} />
);

SimilarAuthorsList.propTypes = {
  similarAuthors: PropTypes.array.isRequired,
};

export default SimilarAuthorsList;
